import { adminApi } from "./adminApi";

export const ADMIN_SESSION_STORAGE_KEY = "admin_user_before_impersonation";

export const impersonationService = {
  async impersonateUser(userId, payload) {
    const res = await adminApi.post(`/users/${userId}/impersonate`, payload);
    return res.data;
  },

  storeImpersonatedSession(currentUser, impersonatedUser) {
    localStorage.setItem(
      ADMIN_SESSION_STORAGE_KEY,
      JSON.stringify(currentUser)
    );
    localStorage.setItem("user", JSON.stringify(impersonatedUser));
  },

  restoreAdminSession() {
    const adminUser = localStorage.getItem(ADMIN_SESSION_STORAGE_KEY);

    if (adminUser) {
      localStorage.setItem("user", adminUser);
      localStorage.removeItem(ADMIN_SESSION_STORAGE_KEY);
      return JSON.parse(adminUser);
    }

    localStorage.removeItem("user");
    localStorage.removeItem(ADMIN_SESSION_STORAGE_KEY);
    return null;
  },
};
